module.exports = __webpack_public_path__ + "static/media/ubs.b2d95114.svg";